module.exports = __webpack_public_path__ + "img/product_category_banner.8ef676b.jpg";